




































































import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import {
  Action,
  Getter,
  Mutation,
} from 'vuex-class';
import Modal from '@/components/Modal.vue';
import {Application} from '@/types';
import Transformation from '@/classes/transformation';
import Dialog from '@/components/Dialog.vue';
import GenericButton from '@/components/GenericButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';

@Component({
  components: {
    ConfirmButton,
    GenericButton,
    Dialog,
    Modal,
  },
})
export default class FlowUI extends Vue {

  @Getter private activeOrganisation: any;
  @Getter private activeOrganisationId: any;
  @Getter private applications!: any;
  @Getter private login: any;
  @Action private addApplicationsAsync: any;
  @Action private createAdminApplicationAsync: any;
  @Action private deleteAdminApplicationAsync: any;
  @Action private addToastErrorMessage: any;

  private saving = false;
  private validated = false;
  private showButton: boolean = false;
  private showPublishOptions: boolean = false;
  private publishList: any[] = [];
  private newDashboard: any = {
    name: '',
    tabIndex: 0,
  };
  private dashboardAddErrors: string[] = [];

  private async mounted() {
    await this.refreshApplications();
  }

  private getSlot(ref: string) {
    const split = ref.split('/#!/');
    if (split.length === 2) {
      return split[1];
    }
    return 0;
  }

  private async removeDashboard(id: number) {
    this.saving = true;

    try {
      await this.deleteAdminApplicationAsync(id);
    } catch (e) {
      const err = e as Error;
      this.addToastErrorMessage('Could not delete application: ' + err.message);
    } finally {
      await this.refreshApplications();
      this.saving = false;
    }
  }

  private async addDashboard() {
    this.saving = true;
    let nrSlug = '';
    if (this.newDashboard.tabIndex > 0) {
      nrSlug = `/#!/${this.newDashboard.tabIndex.toString()}`;
    }
    const payload = {
      name: this.newDashboard.name.trim(),
      type: 'nodered',
      organisations: [this.activeOrganisationId],
      reference: `https://${this.getOrgNRSubdomain()}.daizy.io/ui${nrSlug}`,
    };
    if (await this.createAdminApplicationAsync(payload)) {
      await this.refreshApplications();
      this.newDashboard.name = ' ';
      this.newDashboard.tabIndex = 0;
      this.saving = false;
    }
  }

  private async refreshApplications() {
    this.publishList = [];
    await this.addApplicationsAsync();
    for (const app of this.applications.applications) {

      if (app.type === 'nodered') {
        this.publishList.push({
          id: app.id,
          name: app.name,
          slot: this.getSlot(app.reference),
        });
      }
    }
  }

  private getOrgNRSubdomain() {
    return Transformation.hashOrgSlug(this.activeOrganisation[0].slug);
  }

  private iFrameLoaded() {
    this.toggleButton();
  }

  private toggleButton() {
    this.showButton = true;
  }

  private get getNRUrl() {
    const orgSlug = this.getOrgNRSubdomain();
    return `https://${orgSlug}.daizy.io/ui`;
  }
}
